// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperLinkElement-cls1__a3aad22bb02a582ec54a{/*!*/}.PaperLinkElement-cls2___621ce83375cdd57c776{margin-right:2px;top:2px;position:relative;width:14px;height:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperLinkElement-cls1__a3aad22bb02a582ec54a",
	"cls2": "PaperLinkElement-cls2___621ce83375cdd57c776 PaperLinkElement-cls1__a3aad22bb02a582ec54a"
};
export default ___CSS_LOADER_EXPORT___;
